module.exports = __webpack_public_path__ + "static/media/icon-error.ccfe2f10.svg";